import { render, staticRenderFns } from "./NarrativeView.vue?vue&type=template&id=faecc1ce&scoped=true&"
import script from "./NarrativeView.vue?vue&type=script&lang=js&"
export * from "./NarrativeView.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeView.vue?vue&type=style&index=0&id=faecc1ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faecc1ce",
  null
  
)

export default component.exports